/**
 * Centralized configuration for environment-dependent values.
 * No fallbacks — if a variable is unset, it stays undefined and
 * the first fetch will fail visibly instead of silently hitting localhost.
 */

export const BACKEND_URL = process.env.NEXT_PUBLIC_BACKEND_URL!;

/** The address users are told to write to for access, BYO setup and account
 *  help. Read here and nowhere else, so a change of mailbox is one variable. */
export const SUPPORT_EMAIL = process.env.NEXT_PUBLIC_SUPPORT_EMAIL!;
